import { fromJS } from "immutable";
import * as queryString from "query-string";

const GameUtils = {
  getGames(context, link) {
    if (link) {
      let params = { size: 10 };

      context.setState({ isLoading: true });

      context.props
        .fetchGames(link, params)
        .then((resp) => {
          context.setState({
            games: fromJS(resp),
            isLoading: false,
          });
        })
        .catch(() => {
          context.setState({ isLoading: false });
        });
    } else {
      context.setState({ isLoading: false });
    }
  },

  onGameItemClick(context, game, rel) {
    const props = context.props;
    if (
      props.isMultiGame &&
      (!props.isMobile || (props.isMobile && props.isOneClickPlayEnabled))
    ) {
      let games = fromJS([]);
      let gameItem = fromJS({
        gameId: game.get("gameId"),
        playType: rel,
        nav: props.link ? props.link.get("rel") : null,
      });

      games = games
        .push(gameItem)
        .push(null)
        .push(null)
        .push(null);

      let gamesEnc = btoa(encodeURIComponent(JSON.stringify(games.toJSON())));

      let params = { games: gamesEnc };
      let newLoc = `${props.location.pathname}?${queryString.stringify(
        params
      )}`;

      props.navigateTo(newLoc);
    } else if (!props.isMultiGame && !props.isMobile) {
      let params = {
        gameId: game.get("gameId"),
        playType: rel,
        nav: game,
      };

      let newLoc = `${props.location.pathname}?${queryString.stringify(
        params
      )}`;
      props.navigateTo(newLoc);
    } else {
      let params = {
        playType: rel,
        nav: props.link.get("rel"),
        gameId: game.get("gameId"),
        isMobile: props.isMobile,
      };

      props.setGameAction(params);
    }
  },
};

export default GameUtils;
